var React = require('react');

function SearchIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M6 2.19922C3.79086 2.19922 2 3.99008 2 6.19922C2 8.40836 3.79086 10.1992 6 10.1992C8.20914 10.1992 10 8.40836 10 6.19922C10 3.99008 8.20914 2.19922 6 2.19922ZM0 6.19922C0 2.88551 2.68629 0.199219 6 0.199219C9.31371 0.199219 12 2.88551 12 6.19922C12 7.49505 11.5892 8.69493 10.8907 9.67575L15.7071 14.4921C16.0976 14.8826 16.0976 15.5158 15.7071 15.9063C15.3166 16.2969 14.6834 16.2969 14.2929 15.9063L9.47653 11.09C8.49572 11.7884 7.29583 12.1992 6 12.1992C2.68629 12.1992 0 9.51293 0 6.19922Z","fill":"#9CA3AF"}));
}

SearchIcon.defaultProps = {"width":"16","height":"17","viewBox":"0 0 16 17","fill":"none"};

module.exports = SearchIcon;

SearchIcon.default = SearchIcon;
